import React from 'react';

import repositoryCss from './repository.css';

import { PackageGroupsWrapper } from './package-groups';
import { PackagesWrapper } from './package-list';
import { UploadPackagesWrapper } from './upload-packages';
export interface IErrorProps {
    key: number | string;
    message: string;
}

export enum IPackagesComponent {
    PACKAGES = 'PACKAGES',
    UPLOAD_PACKAGES = 'UPLOAD_PACKAGES',
    MANAGE_PACKAGE_GROUPS = 'MANAGE_PACKAGE_GROUPS',
}

interface IPackageContextProps {
    toPackageGroupsTable: () => void;
    toUploadPackage: () => void;
    toPackagesTable: () => void;
}

const packageContext = React.createContext<IPackageContextProps>(null);
export const usePackageContext = () => React.useContext(packageContext);

export const PackageTab = () => {
    const [componentState, setComponentState] = React.useState<IPackagesComponent>(IPackagesComponent.PACKAGES);

    const navigationProps: IPackageContextProps = {
        toPackageGroupsTable: () => setComponentState(IPackagesComponent.MANAGE_PACKAGE_GROUPS),
        toUploadPackage: () => setComponentState(IPackagesComponent.UPLOAD_PACKAGES),
        toPackagesTable: () => setComponentState(IPackagesComponent.PACKAGES),
    };

    return (
        <packageContext.Provider value={navigationProps}>
            <div className={repositoryCss.pane}>
                {componentState == IPackagesComponent.PACKAGES && <PackagesWrapper />}
                {componentState == IPackagesComponent.MANAGE_PACKAGE_GROUPS && <PackageGroupsWrapper />}
                {componentState == IPackagesComponent.UPLOAD_PACKAGES && <UploadPackagesWrapper />}
            </div>
        </packageContext.Provider>
    );
};
